<template>
  <div>
    <div class="bar" :style='style' :class="this.color"></div>
    <div class="progress-wrapper">
      <slot></slot>
    </div>  
  </div>
</template>

<script>
  export default {
    name: 'vue-progress-scroll',
    data() {
      return {
        style: null,
        // barColor: color
      }
    },
    mounted() {
      this.$nextTick(function() {
        var theElement = document.getElementsByClassName('progress-wrapper')[0];

        window.addEventListener('scroll', () => {

          var height = theElement.getBoundingClientRect().height - (window.innerHeight);

          var top = theElement.getBoundingClientRect().top;
          var calculatedValue = Math.abs(top) / height * 100;
          
          if (top  < 0) {
            this.style = 'width:' + calculatedValue + '%';
          } else {
            this.style = 'width: 0';
          }

        }, { passive: true });
      });

    },
    props: [
      'color'
    ]
  }
</script>


// WEBPACK FOOTER //
// src/components/small-components/ScrollProgressBar.vue